module.exports = __webpack_public_path__ + "img/info.d101d656.svg";